// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function calendarsList() {
  return http<{
    calendars: Array<{
      id: number
      name: string
      pinned: boolean
    }>
  }>({
    url: "/api/v1/calendars/",
    method: "get",
  })
}
